import type { Account } from "@home-finance-manager/shared/types/accounts"

let onCurrentAccountChange: (account: Account) => void = () => {}

/**
 * Set the callback function to be called when the current account changes
 * @param callback - The callback function to be called when the current account changes
 */
export function setOnCurrentAccountChange(callback: (account: Account) => void) {
  onCurrentAccountChange = callback
}

/**
 * Call the callback with the current account
 */
export function triggerCurrentAccountChange(account: Account) {
  onCurrentAccountChange(account)
}
